import React from 'react';
import { CUSTOMER_VIEW_CUSTOMERS_LIST } from '../../../Constants';
import '../../../styles.css';
import { useTranslation } from 'react-i18next';
import LineInfo from './LineInfo';
import MobileDataGrid from '../../MobileDataGrid';

export default function Customer(props) {
  const { t } = useTranslation();

  const columns = [
    { field: 'use_name', headerName: t('Line User Name')},
    { field: 'number', headerName: t('Number')},
    { field: 'create_date', headerName: t('Created at')},
    //{ field: 'last_call', headerName: t('Last Call')}
    { 
      field: 'last_call', 
      headerName: t('Last Call'),
      renderCell: (params) => {
        //console.log(params);
        return (
          <div style={{ color: (((new Date() - new Date(params.last_call)) / (1000 * 60 * 60 * 24)) > 5 && localStorage.getItem('show_red_inactive_lines') === "true") ? "red" : "black"}}>
            {params.last_call}
          </div>
        );
      }
    },
  ];

  const renderRowExpansion = (cellValues) =>{
    return <LineInfo
      line={cellValues}
      customer={props.customer}
      onRequestRemoveLine={props.onRequestRemoveLine}
       />;
  }

  return (  
    <div className="customer-information-view"
    >
      <div className='title'>
        <div className='back' onClick={() => {props.setCustomerView(CUSTOMER_VIEW_CUSTOMERS_LIST);}}>
            <img src='/design-images/arrow-around.svg' className='arrow-around' />
            <div className='text'>{t("Back to customers management")}</div>
        </div>
        <div className='text main'>{t("Customer Information")}</div>
      </div>
      <div className='customer-info'>
        <div className='item'>{t('Name')} | {props.customer.name}</div>
        <div className='item'>{t('Number')} | {props.customer.phone}</div>
        <div className='item'>{t('Last Updated at')} | {props.customer.update_date}</div>
        <div className='item' style={{color: (((new Date() - new Date(props.customer.last_out_call)) / (1000 * 60 * 60 * 24)) > 5 && localStorage.getItem('show_red_inactive_lines') === "true") ? "red" : "black"}}> {t('Last Call')} | {props.customer.last_out_call}</div>
      </div>
      <div className='ci-mobile-lines-bar'>
        <div className='ci-sort-group'>
          <span className='sort-by-label'>הצג לעמוד:</span>
          <select className='psh-select' value={props.pageSize}
            onChange={(e) => { props.setPage(0); props.setPageSize(Number(e.target.value)); }}>
            {(props.pageSizeOptions || []).map((size) => <option key={size} value={size}>{size}</option>)}
          </select>
        </div>
        {/* the API has no per-customer lines export - the file is built in the browser */}
        <button type='button' className='ci-export-btn' onClick={props.onExportLines} disabled={props.exporting}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          <span>{props.exporting ? 'מייצא...' : 'ייצוא קווים'}</span>
        </button>
      </div>
      <MobileDataGrid
      serverPaged={true}
      rowCount={props.rowCount}
      rows={props.rows}
      columns={columns}
      loading={props.loading}
      mainColumn="use_name"
      page={props.page}
      pageSize={props.pageSize}
      onPageChange={(newPage) => {
        props.setPage(newPage);
      }}
      onPageSizeChange={(newPageSize) => {
        props.setPage(0);
        props.setPageSize(Number(newPageSize));
      }}
      renderRowExpansion={renderRowExpansion}
      visibleExtraColumn="number"
      expandedRowIds={props.expandedRowIds}
      setExpandedRowIds={props.setExpandedRowIds}
      />
    </div>
  );
}
